import { getFeatureFlag, isString } from "@sinch/feature-flags";
import { loadScript } from "../helpers/loadScript";

export const initGoogleTagManager = async () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };

  const gtmId = getFeatureFlag("gtmId", isString, "null");
  if (!gtmId || gtmId === "null") {
    return console.warn("Couldn't find a gtm Id");
  }

  // Insert Google Tag Manager noscript fallback
  const noscript = document.createElement("noscript");
  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);

  gtag("js", new Date());
  gtag("config", gtmId);
  loadScript({
    src: `https://www.googletagmanager.com/gtm.js?id=${gtmId}`,
  });
};
